import config from 'config';
import axios from 'axios';

const ROOT = config.API_BASE_URL;

class GroupsService {

  static findAllByAMTSupportEntry(token) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}groups/findAllByAMTSupportEntry?token=${token}`).then((data) => {
        resolve({ groups: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getAll(options=[]) {
    return new Promise((resolve, reject) => {
      let params = options.length == 0 ? '' : '?' + options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');      
      axios.get(`${ROOT}groups${params}`).then((data) => {
        resolve({ groups: data.data.content, page: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static get(groupId, detail=false) {
    return new Promise((resolve, reject) => {
      let detailParms = detail ? '?projection=detail' : '';
      axios.get(`${ROOT}groups/${groupId}${detailParms}`).then((data) => {
        resolve({ group: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static save(group) {
    return new Promise((resolve, reject) => {
      axios.patch(`${ROOT}groups/${group.id}`, group).then((data) => {
        resolve(data);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static add(group) {
    return new Promise((resolve, reject) => {
      axios.post(`${ROOT}groups`, group).then((data) => {
        resolve(data.data);
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static listAll() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}groups/listAll`).then((data) => {
        resolve({ groups: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static listAllGroupingsForGroup(groupId) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}groups/${groupId}/listAllGroupings`).then((data) => {
        resolve({ groupings: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static remove(groupId) {
    return new Promise((resolve, reject) => {
      axios.delete(`${ROOT}groups/${groupId}`).then((data) => {
        resolve(data);
      }).catch((err) => {
        reject(err);
      });
    });
  }

}

export default GroupsService;
